module.exports = __webpack_public_path__ + "img/3-2.173e6c16.png";